import { render, staticRenderFns } from "./train-add-or-update.vue?vue&type=template&id=d8eef55e&lang=pug"
import script from "./train-add-or-update.vue?vue&type=script&lang=js"
export * from "./train-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./train-add-or-update.vue?vue&type=style&index=0&id=d8eef55e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports